<div
  class="container l-align-items-center"
  tooltip="{{ order.stageLongDescr }}"
>
  <span
    *ngIf="!order.stageRepeatSw && order.stageId != -1"
    class="stage-circle"
    [style.background-color]="getStageColor()"
  ></span>
  <img *ngIf="order.stageId == -1" src="assets\img\new-alert.svg" />
  <i
    *ngIf="order.stageRepeatSw"
    class="fas fa-redo-alt"
    [style.color]="getStageColor()"
  ></i>
  &nbsp;&nbsp;
  <span class="stage-descr" [class.new]="order.stageId == -1">
    {{ order.stageDescr }}</span
  >
</div>
